(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/matchview-statistics.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/matchview-statistics.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.views.MatchViewStatistics = Backbone.Marionette.View.extend({
    log: new svs.core.log.Logger('svs.tipset.views.MatchViewStatistics'),
    currentMatch: 0,

    initialize: function() {
      this.uid = svs.tipset.getUid();
      this.observer = this;
      this.on('resize', this.resizeRoyalSlider, this);
    },

    render: function() {
      svs.tipset.calls.addCall('match-view-statistics ' + this.uid);
      var currentMatch = svs.tipset.collections.matchlist.getCurrentMatch(),
        match = currentMatch.get('match');
      if (!currentMatch.isPlayer) {
        this.prepTabs(match, this.getLeagueId(match));
        try {
          this.embedStat = new svs.app.tab_view.TabView({
            tabs: this.tabs,
            path: false,
            selected: 'matchinfo'
          });
          this.listenTo(this.embedStat, 'onChange', this.slideChangeHandler);

          if (!svs.core.detect.formfactor.mobile()) {
            this.embedStat.$el
              .removeClass('rsDefault')
              .addClass('rsInverted-large');
          }

          this.$el.html(this.embedStat.el);
        } catch (err) {
          this.log.debug('Ingen statistik: ' + err.message);
        }
      }
      this.delegateEvents();
      svs.events.publish('/loader/hide');
      return this.el;
    },

    onClose: function() {
      this.undelegateEvents();
      this.stopListening();
    },

    onDestroy: function() {
      this.onClose();
    },

    prepTabs: function(match, leagueId) {
      this.tabs = [];
      var matchId = match.matchId;

      this.tabs.push({
        caption: 'TT-Nyheter',
        view: new svs.statistics.newstt.views.NewsTTList({
          params: {
            parentId: 'svs-workarea-articles-newstt',
            domainCategories: 'svs-domain-sport-events/' + matchId,
            numOfArticles: 100,
            newsClass: 'statistic-element',
            useTabletGradient: false,
            tabRefId: 'nyheter'
          }
        }),
        id: 'nyheter',
        cssClass: 'slide-inverted'
      });

      if (!svs.tipset.collections.matchlist.getCurrentMatch().get('isPlayer')) {
        this.tabs.push({
          caption: 'Tabell',
          view: new svs.statistics.views.StatGeneralTables({
            params: {
              matchId: matchId,
              leagueId: leagueId,
              parent: this.observer,
              match: match
            }
          }),
          id: 'tabell',
          cssClass: 'slide-inverted'
        });
      }
      this.tabs.push({
        caption: 'Matchinfo',
        view: new svs.statistics.views.StatMatchEvents({
          params: { matchId: matchId, parent: this.observer }
        }),
        id: 'matchinfo',
        cssClass: 'slide-inverted'
      });
      this.tabs.push({
        caption: 'Statistik',
        view: new svs.statistics.views.StatMatchStatistics({
          params: { matchId: matchId, parent: this.observer }
        }),
        id: 'statistik',
        cssClass: 'slide-inverted'
      });
      this.tabs.push({
        caption: 'Laguppställning',
        view: new svs.statistics.views.StatMatchLineup({
          params: {
            matchId: matchId,
            leagueId: leagueId,
            parent: this.observer
          }
        }),
        id: 'laguppstallning',
        cssClass: 'slide-inverted'
      });
    },

    slideChangeHandler: function(e) {
      this.observer.trigger('closeHandler');
      this.observer.trigger('initHandler', e);
    },

    resizeRoyalSlider: function() {
      if (_.isObject(this.embedStat)) {
        this.embedStat.resize();
      }
    },

    getLeagueId: function(match) {
      return match && match.league && match.league.id;
    }
  });
})(Backbone, _, svs);

 })(window);